module.exports = __webpack_public_path__ + "img/2.b214d523.png";